const Interventions = (props) => {

  let interventions = props.data?.synonyms;
  let interventionText = "";

  if (interventions && interventions.length > 0) {
    for(var i = 0; i < interventions.length; i++){
      let tempCond = interventions[i];
      interventionText += tempCond.name
      if(i < interventions.length - 1){
        interventionText += ", "
      }
    }

  }
  return (
    <div>{interventionText}</div>
  );
};

export default Interventions;